module.exports = __webpack_public_path__ + "static/media/rev1.0c9fcbc0.png";